import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import StewartInput from "controls/global/stewart-input";
import { PolicyDataErrorRecord } from "entities/UIModel/PolicyDataErrorRecord";
import React, { useRef, useState } from "react";

interface Props {
  name: keyof PolicyDataErrorRecord;
  disabled?: boolean;
  onChange: (name: keyof PolicyDataErrorRecord, value: string | null) => void;
  defaultValue?: string;
}

const InputSearch = ({ name, disabled, onChange, defaultValue }: Props) => {
  const [value, setValue] = useState<string>(defaultValue ? defaultValue : "");
  const searchInputRef = useRef<HTMLInputElement>(null);

  const clearInput = () => {
    setValue("");
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
      const changeEvent = {
        target: searchInputRef.current,
      } as React.ChangeEvent<HTMLInputElement>;
      handleInputChange(changeEvent);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = event.target.name as keyof PolicyDataErrorRecord;
    const currentValue = event.target.value;
    if (value !== event.target.value.trim()) {
      onChange(fieldName, currentValue);
    }
    setValue(currentValue || "");
  };

  return (
    <StewartInput
      {...{ name }}
      id={name}
      onChange={handleInputChange}
      disabled={disabled}
      label="Search"
      inputRef={searchInputRef}
      InputProps={{
        endAdornment: !!value && (
          <IconButton onClick={clearInput} disabled={disabled}>
            <CloseIcon />
          </IconButton>
        ),
      }}
      InputLabelProps={{
        shrink: !!value,
      }}
      value={value}
    />
  );
};

export default InputSearch;
